import EcoImg from 'eco-design/base/eco-img';
import { FC } from 'react';
import { createPortal } from 'react-dom';
import styles from './index.module.scss';

interface ModalProps {
    visible: boolean;
    onClose: () => void;
    title?: string;
    children: React.ReactNode;
}

const CloseIcon = () => (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M18 6L6 18" stroke="black" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
        <path d="M6 6L18 18" stroke="black" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
);

const Modal: FC<ModalProps> = ({ visible, onClose, title, children }) => {
    if (!visible) return null;

    return createPortal(
        <div className={styles.modal}>
            <div className="modal-overlay" onClick={onClose} />
            <div className="modal-container">
                <div className="modal-header">
                    <h3 className="modal-title">{title}</h3>
                    <button className="modal-close" onClick={onClose}>
                        <CloseIcon />
                    </button>
                </div>
                <div className="modal-content">{children}</div>
                <div className="background-img">
                    <EcoImg
                        pc="https://websiteoss.ecoflow.com/upload/image/1753671650520/pc.png"
                        pad="https://websiteoss.ecoflow.com/upload/image/1753671650737/pad.png"
                        h5="https://websiteoss.ecoflow.com/upload/image/1753671650349/h5.png"
                    />
                </div>
            </div>
        </div>,
        document.body,
    );
};

export default Modal;
